module.exports = __webpack_public_path__ + "static/media/azkar 2.6edd6e2a.jpg";